module.exports = __webpack_public_path__ + "static/media/Afaq_45001_g.3ea4794a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Afaq_45001_g.png
// module id = 1735
// module chunks = 0